import React, { memo } from 'react';
import { MdAccountTree, MdStore } from 'react-icons/md';
import { Dropdown, Tooltip, Whisper } from 'rsuite';
import {
    GroupByType,
    ProductType,
    selectorCurrentGroupBy,
    selectorCurrentProductType,
    useSuppliersExhibitionStore
} from '../../../../../../../store/useSuppliersExhibitionStore';
import styles from './SuppliersExhibitionHeader.module.scss';

const SuppliersExhibitionHeader: React.FC = () => {
    const currentGroupBy = useSuppliersExhibitionStore(selectorCurrentGroupBy);
    const currentProductType = useSuppliersExhibitionStore(selectorCurrentProductType);
    const updateExhibitionType = useSuppliersExhibitionStore((state) => state.updateExhibitionType);

    const handleGroupSelect = (groupBy: GroupByType) => {
        updateExhibitionType(groupBy, currentProductType);
    };

    const handleProductSelect = (productType: ProductType) => {
        updateExhibitionType(currentGroupBy, productType);
    };

    const groupByLabels: Record<GroupByType, string> = {
        CLUSTER: 'Cluster',
        STORE: 'Loja',
        NETWORK: 'Toda a Rede',
    };

    const productTypeLabels: Record<ProductType, string> = {
        PRODUCT: 'Produto',
    };

    const selectedGroupByLabel = groupByLabels[currentGroupBy];
    const selectedProductTypeLabel = productTypeLabels[currentProductType];

    return (
        <div className={styles['suppliers-exhibition-header']}>
            <span className={styles['suppliers-exhibition-header__action-container']}>
                <Whisper placement="top" speaker={<Tooltip>Agrupar por</Tooltip>}>
                    <Dropdown
                        title={selectedGroupByLabel}
                        icon={<MdStore className={styles['suppliers-exhibition-header__icon']} />}
                    >
                        <Dropdown.Item
                            className={styles['suppliers-exhibition-header__item']}
                            id="group-by-store"
                            onSelect={() => handleGroupSelect('STORE')}
                        >
                            Loja
                        </Dropdown.Item>
                        <Dropdown.Item
                            className={styles['suppliers-exhibition-header__item']}
                            id="group-by-cluster"
                            onSelect={() => handleGroupSelect('CLUSTER')}
                        >
                            Cluster
                        </Dropdown.Item>
                        <Dropdown.Item
                            className={styles['suppliers-exhibition-header__item']}
                            id="group-by-network"
                            onSelect={() => handleGroupSelect('NETWORK')}
                        >
                            Toda a Rede
                        </Dropdown.Item>
                    </Dropdown>
                </Whisper>

                <Whisper placement="bottom" speaker={<Tooltip>Exibir por</Tooltip>}>
                    <Dropdown
                        title={selectedProductTypeLabel}
                        icon={<MdAccountTree className={styles['suppliers-exhibition-header__icon']} />}
                    >
                        <Dropdown.Item
                            className={styles['suppliers-exhibition-header__item']}
                            id="display-by-product"
                            onSelect={() => handleProductSelect('PRODUCT')}
                        >
                            Produto
                        </Dropdown.Item>
                    </Dropdown>
                </Whisper>
            </span>
        </div>
    );
};

export default memo(SuppliersExhibitionHeader);
